import Vue from 'deps/vue';

// 插件
Vue.use(Vue => {
  // 添加实例属性
  Vue.prototype.$const = {
    PinTaunStatus: {
      PENDING: 1,
      EXPIRED: 2,
      COMPLETE: 3,
    },
  };
});
